export const CORPUS_TYPES = {
  PREDEFINED: 'predefined',
  CUSTOM: 'custom',
  SAVED: 'saved',
  RESULTS: 'results' // For a corpus definition that is saved with the saved results
};
